import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import Box from "@mui/material/Box";
import { DatePickerToolbar } from "@mui/x-date-pickers/DatePicker";
import { makeStyles } from "../Utilities/ThemeHelper";
import { DateTimePickerToolbar, TimePickerToolbar } from "@mui/x-date-pickers";
const useStyles = makeStyles(theme => ({
  toolbar: {
    background: theme.palette.primary.main,
    color: "#FFF",
    "& span": {
      color: "rgba(255, 255, 255, 0.54)"
    },
    "& > span": {
      color: "#FFF !important"
    },
    "& h4": {
      color: "#FFF"
    },
    "& .Mui-selected": {
      color: "#FFF !important"
    }
  }
}));
export const CustomDatePickerToolbar = props => {
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(Box, {
    className: props.className
  }, /*#__PURE__*/React.createElement(DatePickerToolbar, _extends({}, props, {
    className: classes.toolbar
  })));
};
export const CustomTimePickerToolbar = props => {
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(Box, {
    className: props.className
  }, /*#__PURE__*/React.createElement(TimePickerToolbar, _extends({}, props, {
    className: classes.toolbar
  })));
};
export const CustomDateTimePickerToolbar = props => {
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(Box, {
    className: props.className
  }, /*#__PURE__*/React.createElement(DateTimePickerToolbar, _extends({}, props, {
    className: classes.toolbar
  })));
};